import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {createSelector} from 'reselect';
import _ from 'lodash';
import cx from 'classnames';

import { ModalTypes } from 'constants/constants';
import UIState, {selectModals} from 'store/UIState';

import { ModalCloseButton } from 'components/Button';

import LoginModal from 'modals/LoginModal';
import SignupModal from 'modals/SignupModal';
import ForgotPasswordModal from 'modals/ForgotPasswordModal';
import HealthCheckModal from 'modals/HealthCheckModal';
import CreateUserModal from 'modals/CreateUserModal';
import ChannelPicker from 'modals/ChannelPicker';
import CampaignPicker from 'modals/CampaignPicker';
import AddChannel from 'modals/AddChannel';
import LinkUrlModal from 'modals/LinkUrlModal';
import UrlModal from 'modals/UrlModal';
import BrandEditModal from 'modals/BrandEditModal';
import ConfirmModal from 'modals/ConfirmModal';
import ExportModal from 'modals/ExportModal';
import FormModal from 'modals/FormModal';
import ImageModal from 'modals/ImageModal';


const ModalComponents = {
  [ModalTypes.LOGIN]: LoginModal,
  [ModalTypes.SIGNUP]: SignupModal,
  [ModalTypes.FORGOT_PASSWORD]: ForgotPasswordModal,
  [ModalTypes.CREATE_USER]: CreateUserModal,
  [ModalTypes.HEALTH_CHECK]: HealthCheckModal,
  [ModalTypes.CHANNEL_PICKER]: ChannelPicker,
  [ModalTypes.CAMPAIGN_PICKER]: CampaignPicker,
  [ModalTypes.ADD_CHANNEL]: AddChannel,
  [ModalTypes.LINK_URLS]: LinkUrlModal,
  [ModalTypes.CHANNEL_ASSETS]: UrlModal,
  [ModalTypes.BRAND_EDIT]: BrandEditModal,
  [ModalTypes.CONFIRM]: ConfirmModal,
  [ModalTypes.EXPORT]: ExportModal,
  [ModalTypes.FORM]: FormModal,
  [ModalTypes.IMAGE]: ImageModal,
};

// ===========================
// STORE
// ===========================

const selector = createSelector(
  selectModals,
  (modals) => ({
    modals,
  })
);


// ===========================
// MODAL CONTAINER
// ===========================

const ModalContainer = ({...props }) => {
  const dispatch = useDispatch();
  let {modals} = useSelector(selector);
  
  const onModalClose = type => dispatch(UIState.actions.closeModal(type));
  const onBackingClose = () => dispatch(UIState.actions.closeAllModals())
  
  const renderComponent = data => {
    let { component, type, props } = data;
    if(!component) {
      let Mc = ModalComponents[type]
      if(!Mc)
        throw new Error("Missing modal type!");
      component = <Mc />;
    }
    return React.cloneElement(component, {
      ...props,
      key: typeof component,
      onClose: () => onModalClose(type),
      closeModal: () => onModalClose(type)
    });
  }

  
  let open = !_.isEmpty(modals);
  return (
    <div 
      className={cx("g-modal-container", { open })} 
      onClick={onBackingClose}>
      {_.map(modals, data => renderComponent(data))}
      <ModalCloseButton onClick={onBackingClose} color="light" size="xl" />
    </div>);
  
}
export default ModalContainer;
